import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { CreateTaskDialogComponent } from './components/create-task-dialog/create-task-dialog.component';
import { TaskItemComponent } from './components/task-item/task-item.component';
import { ViewAllTaskDialogComponent } from './components/view-all-task-dialog/view-all-task-dialog.component';
import { TasksMaterialModule } from './tasks-material.module';
import { TasksComponent } from './components/tasks/tasks.component';
import { FullLoadingComponent } from '../../core/components/full-loading/full-loading.component';
import { SvgComponent } from '../../core/components/svg-component/svg-component.component';
import { CommentariesComponent } from '../navbar/components/commentaries/commentaries.component';
import { ConfirmDialogComponent } from '../navbar/components/confirm-dialog/confirm-dialog.component';
import { MomentPipe } from '../../core/pipes';
import { DialogComponent } from '../dialog/dialog.component';
import { TasksRoutingModule } from './tasks-routing.module';
import { TasksPageComponent } from './components/tasks-page/tasks-page.component';
import { CircleProgressComponent } from '../../core/components/circle-progress/circle-progress.component';
import { LetDirective } from '@ngrx/component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { tasksFeatureKey, tasksReducer } from './store/tasks.reducer';
import { TasksEffects } from './store/tasks.effects';
import { MatIcon } from '@angular/material/icon';
import { RoundedDropdownComponent } from '../../core/components/rounded-dropdown/rounded-dropdown.component';
import { RoundedPillComponent } from '../../core/components/rounded-pill/rounded-pill.component';
import { SeverityPipe } from '../../core/pipes';
import { CustomScrollbarDirective } from '../../core/directives/scrollbar.directive';
import { DetailsSidebarComponent } from '../../components/sidebar/details-sidebar.component';
import { ValidationService } from '../../core/services/validation.service';
import { Scrollbar2Directive } from '../../core/directives/scrollbar2.directive';
import { TruncateOverflowTextDirective } from '../../core/directives/truncate-overflow-text.directive';
import { TaskStatusPipe } from '../../core/pipes';
import { CommentsComponent } from '../../core/components/comments/comments.component';
import { SafeHtmlPipe } from '../../core/pipes';
import { SystemErrorsPipe } from '../../core/pipes/system-errors.pipe';
import { ButtonComponent } from '../../core/components/button/button.component';
import { SplitByUpperCasePipe } from '../../core/pipes/split-by-uppercase.pipe';
import { StakeholdersInfoComponent } from 'projects/shared/src/lib/core/components/stakeholders-info/stakeholders-info.component';
import { LoadingPillComponent } from '../../core/components/loading-pill/loading-pill.component';

@NgModule({
  declarations: [
    TasksComponent,
    TaskItemComponent,
    ViewAllTaskDialogComponent,
    ConfirmDialogComponent,
    CreateTaskDialogComponent,
    TasksPageComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TasksRoutingModule,
    TasksMaterialModule,
    TranslateModule,
    SvgComponent,
    FullLoadingComponent,
    DialogComponent,
    CommentariesComponent,
    CircleProgressComponent,
    LetDirective,
    StoreModule.forFeature(tasksFeatureKey, tasksReducer),
    EffectsModule.forFeature([TasksEffects]),
    MatIcon,
    RoundedDropdownComponent,
    RoundedPillComponent,
    MomentPipe,
    SeverityPipe,
    CustomScrollbarDirective,
    DetailsSidebarComponent,
    Scrollbar2Directive,
    TruncateOverflowTextDirective,
    TaskStatusPipe,
    CommentsComponent,
    SafeHtmlPipe,
    SystemErrorsPipe,
    ButtonComponent,
    SplitByUpperCasePipe,
    StakeholdersInfoComponent,
    LoadingPillComponent,
  ],
  exports: [TasksComponent, CreateTaskDialogComponent],
  providers: [ValidationService],
})
export class TasksModule {}
